module.exports = __webpack_public_path__ + "jwplayer.flash.swf";


//////////////////
// WEBPACK FOOTER
// ./vendor/jwplayer.flash.swf
// module id = T8zW
// module chunks = 0